const styles = {
  // ============================================================
  // Layout
  // ============================================================
  centeredContainer: {
    textAlign: 'center',
    padding: '40px 20px',
  },
  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  formActions: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  },

  // ============================================================
  // Progress bars
  // ============================================================
  progressBarTrack: {
    height: '4px',
    backgroundColor: '#e0e0e0',
    borderRadius: '2px',
    overflow: 'hidden',
    marginTop: '16px',
  },
  progressBarTrackSmall: {
    height: '4px',
    backgroundColor: '#e0e0e0',
    borderRadius: '2px',
    overflow: 'hidden',
    marginTop: '8px',
  },
  progressBarFillAnimated: {
    height: '100%',
    backgroundColor: '#2196F3',
    width: '50%',
    animation: 'pulse 1.5s ease-in-out infinite',
  },

  // ============================================================
  // Well variants (Spectrum UNSAFE_style overrides)
  // ============================================================
  sectionWell: {
    backgroundColor: '#f5f5f5',
    padding: '16px',
  },
  infoWell: {
    backgroundColor: '#e3f2fd',
    padding: '16px',
    marginBottom: '16px',
    border: '1px solid #2196F3',
  },
  successWell: {
    backgroundColor: '#e8f5e9',
    padding: '16px',
  },
  warningWell: {
    backgroundColor: '#fffde7',
    padding: '16px',
    marginBottom: '16px',
  },
  warningWellOrange: {
    backgroundColor: '#fff3e0',
    borderLeft: '4px solid #ff9800',
    padding: '16px',
  },
  errorWell: {
    backgroundColor: '#ffebee',
    borderLeft: '4px solid #f44336',
    padding: '16px',
    marginBottom: '16px',
  },
  errorWellCompact: {
    backgroundColor: '#ffebee',
    borderLeft: '4px solid #f44336',
  },
  paymentMethodWell: {
    padding: '16px',
    marginBottom: '16px',
    border: '1px solid #e0e0e0',
  },

  // ============================================================
  // Text variants (Spectrum UNSAFE_style overrides)
  // ============================================================
  textBold: {
    fontWeight: 'bold',
  },
  mutedText: {
    color: '#666',
  },
  mutedLabel: {
    display: 'block',
    color: '#666',
  },
  errorText: {
    color: '#c62828',
  },
  successText: {
    color: '#2e7d32',
  },
  warningTextOrange: {
    color: '#e65100',
  },
  stepIndicator: {
    color: '#999',
  },
  successMessage: {
    color: '#666',
    marginTop: '16px',
    display: 'block',
  },
  countdownText: {
    color: '#999',
    marginTop: '16px',
    display: 'block',
  },
  totalAmount: {
    fontWeight: 'bold',
    color: '#004578',
    fontSize: '18px',
  },
  totalValueBlue: {
    fontWeight: 'bold',
    color: '#2196F3',
  },

  // ============================================================
  // Section headers
  // ============================================================
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '12px',
  },
  sectionTitle: {
    fontWeight: 'bold',
    display: 'block',
  },
  sectionDescription: {
    color: '#666',
    lineHeight: '1.6',
    display: 'block',
    marginTop: '8px',
  },

  // ============================================================
  // Step 1 — Pricing
  // ============================================================
  pricingNote: {
    marginTop: '16px',
    color: '#999',
    display: 'block',
    fontStyle: 'italic',
  },

  // ============================================================
  // Step 2 — Device breakdown
  // ============================================================
  deviceTitle: {
    marginBottom: '12px',
    fontWeight: 'bold',
    display: 'block',
  },
  breakdownRow: {
    marginBottom: '8px',
    paddingBottom: '8px',
    borderBottom: '1px solid #e0e0e0',
  },
  breakdownRowInner: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '4px',
  },
  breakdownDetail: {
    color: '#999',
    fontSize: '13px',
  },
  totalSection: {
    marginTop: '12px',
    paddingTop: '12px',
    borderTop: '2px solid #333',
  },
  monthlyRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '4px',
  },

  // ============================================================
  // Step 3 — Billing
  // ============================================================
  billingGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
  },

  // ============================================================
  // Step 4 — Payment form
  // ============================================================
  summaryRows: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  summaryTotalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '8px',
    borderTop: '1px solid #90caf9',
  },
  errorContent: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
  },
  paymentElementWrapper: {
    padding: '10px',
    backgroundColor: '#fff',
  },
  termsText: {
    color: '#666',
    lineHeight: '1.5',
    fontSize: '14px',
  },
  termsCheckboxRow: {
    marginBottom: '16px',
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
  },
  termsLink: {
    color: '#2196F3',
    textDecoration: 'none',
    fontWeight: '500',
  },

  // ============================================================
  // Footer
  // ============================================================
  footerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: '8px',
  },
  footerActions: {
    display: 'flex',
    gap: '8px',
  },
} as const

export default styles
